(function(window, templates, BubbleView, localizationStrings, highlightDisabler, tabIndex) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.questionSetReviewStatusView = (function() {
      var _containerId = '.question-set-container';
      var _superView = BubbleView.create(_containerId);
      var _viewTemplate;
      var _showAnswersId = '.view-answers-button';
      var _hideAnswersId = '.hide-answers-button';
      var _gradeableDetails;
      var _unGradeableDetails;
      var _readingSelector = '.question-set-results';

      if (templates && templates.question_set_review_status_template) {
         _viewTemplate = templates.question_set_review_status_template;
      } else {
         throw Error('questionSetReviewStatusView: Question Set Review Status Template not found.');
      }

      return {
         setGradeableDetails: function(text) {
            _gradeableDetails = text;
         },
         setUngradeableDetails: function(text) {
            _unGradeableDetails = text;
         },
         getViewMarkup: function() {
            var context = {
               gradeableDetails: _gradeableDetails,
               unGradeableDetails: _unGradeableDetails,
               txtAnswersSubmitted: localizationStrings.strings.accessBtnAnswersSubmitted,
               txtViewAnswers: localizationStrings.strings.accessBtnShowAnswer,
               txtHideAnswers: localizationStrings.strings.accessBtnHideAnswer,
               questionSetResultsTabIndex: tabIndex.QuestionReviewText
            };
            return _viewTemplate(context) + _superView.getOverlayMarkup();
         },
         getHideAnswersControlRef: function() {
            return _hideAnswersId;
         },
         getShowAnswersControlRef: function() {
            return _showAnswersId;
         },
         showView: function() {
            var $container = window.$(_containerId);
            $container.removeClass('minimized');
            _superView.showView();

            var $readableElement = $container.find(_readingSelector);
            $readableElement.focus();
            highlightDisabler.disableHighlights($readableElement);
         },
         hideView: function() {
            window.$(_containerId).addClass('minimized');
            _superView.hideView();
         },
         removeView: _superView.removeView,
         updateViewPosition: _superView.updateViewPosition,
         setBottomOffset: _superView.setBottomOffset,
         pointAt: _superView.pointAt

      };
   }());
}(this, window.TSC.templates, window.TSC.BubbleView, window.TSC.localizationStrings, window.TSC.highlightDisabler, window.TSC.tabIndex));
